import type { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import Index from "./pages/Index/Index";
import AdminLogin from "./pages/AdminLogin/AdminLogin";
import AdminChildren from "./pages/AdminChildren/AdminChildren";
import Child from "./pages/Child/Child";
import Children from "./pages/Children/Children";
import AdminChild from "./pages/AdminChild/AdminChild";
import OfferPage from "./pages/Legal/OfferPage";
import PrivacyPage from "./pages/Legal/PrivacyPage";
import ParentConsentPage from "./pages/Legal/ParentConsentPage";
import AuthService from "./services/authService";

registerLocale("ru", ru);
setDefaultLocale("ru");

const AppBlock = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background: #f9f9fb;
`;

function RequireAuth({ children }: { children: ReactElement }) {
  const user = AuthService.getUser();

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

function RequireAdmin({ children }: { children: ReactElement }) {
  const user = AuthService.getUser();

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!user.isAdmin) {
    return <Navigate to={`/admin/children/${user.id}`} replace />;
  }

  return children;
}

function App() {
  return (
    <AppBlock>
      <Routes>
        <Route index element={<Index />} />
        <Route path="/children" element={<Children />} />
        <Route path="/children/:id" element={<Child />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/parent-consent" element={<ParentConsentPage />} />

        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/children"
          element={
            <RequireAdmin>
              <AdminChildren />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/children/:id"
          element={
            <RequireAuth>
              <AdminChild />
            </RequireAuth>
          }
        />
      </Routes>
    </AppBlock>
  );
}

export default App;
